/** File-type helpers for case-checking document download / inline view. */

export function caseDocumentExtension(fileType: string, filename: string): string {
  let ext = (fileType || "").toLowerCase().replace(/^\./, "");
  if (!ext && filename.includes(".")) {
    ext = filename.split(".").pop()?.toLowerCase() ?? "";
  }
  return ext;
}

/** Browser can show these inline in a new tab; Office formats cannot. */
export function caseDocumentCanViewInline(fileType: string, filename: string): boolean {
  return ["pdf", "png", "jpg", "jpeg", "gif", "webp", "txt"].includes(
    caseDocumentExtension(fileType, filename),
  );
}

export function caseDocumentMimeType(fileType: string, filename: string): string {
  const map: Record<string, string> = {
    pdf: "application/pdf",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    doc: "application/msword",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    xls: "application/vnd.ms-excel",
    png: "image/png",
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    gif: "image/gif",
    webp: "image/webp",
    txt: "text/plain",
  };
  return map[caseDocumentExtension(fileType, filename)] ?? "application/octet-stream";
}
